import {getABTest} from "../../../domain/abtest/abtest-provider";
import {abtest_SBSPage25Variants} from "../interfaces";


/*
export const searchServer = async (query:  string | null, smartSearchFilter:number, currentPage:number) => {
    return get('/api/sitesearch/search?query=' + query + "&smartSearchFilter=" + smartSearchFilter + "&currentPage=" + currentPage + "&itemsPerPage=" + ItemsPerPage);
};

*/


export const getABTest_SBSPage25 = () : abtest_SBSPage25Variants => {
    

    const abtest_SBSPage25 = getABTest('SBSSideBySide');
    const abtest_SBSPage25_Enabled = !!abtest_SBSPage25 && abtest_SBSPage25.isActive;
    let abtestVariant: abtest_SBSPage25Variants =abtest_SBSPage25Variants.oldY;
    if(abtest_SBSPage25_Enabled) {
        switch (abtest_SBSPage25.selected) {
            case 'four_side_by_side' : {
                abtestVariant = abtest_SBSPage25Variants.sideBySide;
                break;
            }
            case 'old_y' : {
                abtestVariant = abtest_SBSPage25Variants.oldY;
                break;
            }
            case 'ultimate_only' : {
                abtestVariant = abtest_SBSPage25Variants.ultimateOnly;
                break;
            }
            default : {
                abtestVariant = abtest_SBSPage25Variants.oldY;
            }
        }
        // sendABTestAnalytics(abtest_SBSPage25);
    }

    return  abtestVariant;

};
